import { Mutex } from 'async-mutex';

// Used by axios interceptors to ensure no requests are made during retry mechanism - where token is refreshed due to expired token
export const axiosInstanceMutex = new Mutex();

// Used by explicit refresh token calls, to ensure no other refresh token calls are made, e.g. switch business, create business entity
// Can't solely use axiosInstanceMutex because that blocks it at the request interceptor level.
// i.e. Once I acquire axiosInstanceMutex lock, then I can't make refresh tokens calls at all externally as I've locked the axios instance.
export const refreshTokenMutex = new Mutex();
